<script setup>
import { ref } from 'vue'

//events raised by component
//const emit = defineEmits(['closeSettingsSourceModal'])

//peoperties set by parent
const props = defineProps({
	source: {
		type: String,
		required: false,
	},
	abbreviations: {
		type: String,
		required: false,
	}	
})	

//reactive field proxies
const activeTab = ref(''); //ref('settings')
const isOpen = ref(false)

//local variables


//methods
 defineExpose({
    openModal
});

function openModal(tab) {
	activeTab.value = tab
	isOpen.value = true
}

</script>

<template>
	<div v-if="isOpen" class="modal-overlay">
		<div class="modal-container">
			<div class="modal-header">
				Key & Source
				<button class="btn-icon btn-close" @click="isOpen = false" aria-label="Close"><i class="fa-solid fa-times"></i></button>
			</div>
			<div class="modal-body">

				<div class="tab">
 					<div class="tab-item" v-show="abbreviations">
						<div class="tab-link" v-on:click="activeTab='abbreviations'">
							<i class="fa-solid fa-book" aria-hidden="true"></i>
							Key
							<div v-show="activeTab==='abbreviations'" class="tab-link-underline" />  
						</div>   
					</div>
					<div class="tab-item">
						<div class="tab-link" v-on:click="activeTab='source'">
							<i class="fa-regular fa-sliders" aria-hidden="true"></i>
							Source
							<div v-show="activeTab==='source'" class="tab-link-underline" />
						</div>     
					</div>
				</div>

				<div v-show="activeTab==='abbreviations'" class="tab-content">
					<span v-html="props.abbreviations" />
				</div>
				<div v-show="activeTab==='source'" class="tab-content">
					<span v-html="props.source" />
				</div>
				
			</div>
			<div class="modal-footer">

			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index:100
}

.modal-container {
	background-color: var(--surface-color-Default);
	display: flex;
	width: 100%;
	max-width: 48.25rem;
	min-height: 33rem; 
	padding: var(--spacing-0, 0rem);
	flex-direction: column;
	align-items: flex-start;
	gap: var(--spacing-3xl, 2.5rem);
	position: relative;
	z-index: 101;
	border-top-left-radius: var(--radius-xl);
	border-top-right-radius: var(--radius-xl);
	border-bottom-left-radius: var(--radius-xl);
	border-bottom-right-radius: var(--radius-xl);		
}

.modal-header {
	display: flex;
	height: 5rem;
	padding: 1.4375rem 2rem 1.5625rem 2rem;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	border-bottom: 1px solid var(--borders-DividerActive, #064291);
	background: var(--surface-brand-Blue, #064291);
	color: var(--text-Inverse, #fff);
	font-family: var(--font-family-Title);
	font-size: var(--font-size-H5);
	border-top-left-radius: var(--radius-xl);
	border-top-right-radius: var(--radius-xl);	
}

.modal-body {
	background: var(--surface-Default, #FFF);
	min-height: 15.0625rem;
	display: flex;
	padding: 0rem var(--spacing-xl, 1.5rem) var(--spacing-xl, 6rem) var(--spacing-xl, 1.5rem);
	flex-direction: column;
	align-items: flex-start;
	gap: var(--spacing-xl, 1.5rem);
	align-self: stretch;	
}

.modal-footer {
	display: flex;
	padding: var(--spacing-lg, 1rem) var(--spacing-xl, 1.5rem);
	justify-content: flex-end;
	align-items: flex-end;
	gap: var(--spacing-lg, 1rem);
	align-self: stretch;
	max-height: 5rem;
	background: var(--surface-default, #FFF);	
}

.tab {
	display: inline-flex;
	justify-content: flex-start;
	align-items: top;
	gap: 1.875rem;	
	margin-right: 1.25rem;
	width: 100%;
	padding-bottom: -1rem;
	border-bottom-color: var(--brand-color-Grey);
	border-bottom-width: .1rem;
	border-bottom-style: solid;
}

.tab-item {
	display: flex;
	padding: .25rem;
	flex-direction: column;
	align-items: center;
	gap: 0.1875rem;
	cursor: pointer;
}

.tab-link-underline {
	background: var(--brand-color-IndicatorsBlue, #064291);
	height: .25rem; 
	width: 100%; 
	margin-top: 0.5rem;
	margin-bottom: -0.25em;
}

:deep(.section-break){
	display: block;
	margin-top: .5rem;
}

.btn-close {
	width: 1rem;
	color: var(--icons-icon-cta-reverse, #FFF);
	background: var(--surface-brand-Blue, #064291);
	font-size: 1.25rem;
	font-style: normal;
	font-weight: 900;
	line-height: normal;
	border: 0;
}

.btn {
	height: 3rem;
	min-width: 5rem;
	min-height: 2.5rem;
	padding: 0.75rem 0.5rem;
	border-radius: 0.5rem;
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-Base, 1.5rem);
}

/* 499px - Mobile */
@media (max-width: 31.1875rem) {  

	.modal-overlay {
		position: absolute;
		top: 8.4375rem; /*  135px; */
		left: 0;
		width: calc(100vw);
		height: calc(100vh);
	}


	.modal-container {
		width: 100%;
		height: 100%;
		justify-content: start;
		position: absolute;
		top: 0;
		border-radius: 0;
	}

	.modal-header {
		border-radius: 0;
	}	
}	
</style>